import { render } from "./water.svg?vue&type=template&id=7abfc41a?inline"
const script = {}
script.render = render

export default script